import SelectedTabActionTypes from './selectedTab.types';

const INITIAL_STATE = {
  customerListTab: 'individual',
  customerInformationTab: 'productList',
  printCDStatusTab: 'notPrinted',
  printMessengerOrderStatusTab: 'notPrinted',
  printVoucherStatusTab: 'notPrinted',
  printChequeStatusTab: 'notPrinted',
  messengerOrderPreviewTypeTap: 'CDproduct',
  approvalTypeTap: 'individual',
  approvalCifInfoTypeTab: 'riskInfo',
  approvalCustomerTypeTab: 'individual',
  cdStatusTypeTab: 'uncompletedList',
  paymentApprovalStatusTabs: {
    transfer: 'pending',
    cheque: 'pending',
    pdc: 'pending'
  },
  nearlyDueStatusTab: 'waiting',
  returnCDStatusTab: 'pending',
  withdrawApprovalStatusTab: 'pending',
  returnChequeStatusTab: 'RETURNED'
};

const selectedTabReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SelectedTabActionTypes.SET_CUSTOMER_LIST_TAB:
      return {
        ...state,
        customerListTab: action.payload
      };
    case SelectedTabActionTypes.SET_CUSTOMER_INFORMATION_TAB:
      return {
        ...state,
        customerInformationTab: action.payload
      };
    case SelectedTabActionTypes.SET_PRINT_CD_STATUS_TAB:
      return {
        ...state,
        printCDStatusTab: action.payload
      };
    case SelectedTabActionTypes.SET_PRINT_MESSENGER_ORDER_STATUS_TAB:
      return {
        ...state,
        printMessengerOrderStatusTab: action.payload
      };
    case SelectedTabActionTypes.SET_PRINT_VOUCHER_STATUS_TAB:
      return {
        ...state,
        printVoucherStatusTab: action.payload
      };
    case SelectedTabActionTypes.SET_PRINT_CHEQUE_STATUS_TAB:
      return {
        ...state,
        printChequeStatusTab: action.payload
      };
    case SelectedTabActionTypes.SET_MESSENGER_ORDER_PREVIEW_TYPE_TAB:
      return {
        ...state,
        messengerOrderPreviewTypeTap: action.payload
      };
    case SelectedTabActionTypes.SET_APPROVAL_TYPE_TAB:
      return {
        ...state,
        approvalTypeTap: action.payload
      };
    case SelectedTabActionTypes.SET_APPROVAL_CIF_INFO_TYPE_TAB:
      return {
        ...state,
        approvalCifInfoTypeTab: action.payload
      };
    case SelectedTabActionTypes.SET_APPROVAL_CUSTOMER_TYPE_TAB:
      return {
        ...state,
        approvalCustomerTypeTab: action.payload
      };
    case SelectedTabActionTypes.SET_CD_STATUS_TYPE_TAB:
      return {
        ...state,
        cdStatusTypeTab: action.payload
      };
    case SelectedTabActionTypes.SET_PAYMENT_APPROVAL_STATUS_TABS:
      return {
        ...state,
        paymentApprovalStatusTabs: {
          ...state.paymentApprovalStatusTabs,
          ...action.payload
        }
      };
    case SelectedTabActionTypes.SET_NEARLY_DUE_STATUS_TAB:
      return {
        ...state,
        nearlyDueStatusTab: action.payload
      };
    case SelectedTabActionTypes.SET_RETURN_CD_STATUS_TAB:
      return {
        ...state,
        returnCDStatusTab: action.payload
      };
    case SelectedTabActionTypes.SET_WITHDRAW_APPROVAL_STATUS_TAB:
      return {
        ...state,
        withdrawApprovalStatusTab: action.payload
      };
    case SelectedTabActionTypes.SET_RETURN_CHEQUE_STATUS_TAB:
      return {
        ...state,
        returnChequeStatusTab: action.payload
      };
    default:
      return state;
  }
};

export default selectedTabReducer;
